<template>
  <b-list-group-item>
    {{plitem.name}}
    <a style="float: right;" :href="'#'+$route.path">
      <b-icon icon="x-circle" variant="danger" font-scale="1.5" v-b-popover.hover.right="'Remove Item from Product List'" @click="emitRemovePLItem"></b-icon>
    </a>
  </b-list-group-item>
</template>
<script>
export default {
  name: 'PLItems',
  props: ['plitem', 'productlist_id', 'totalplitems'],
  data () {
    return {

    }
  },

  methods: {
    emitRemovePLItem() {
      this.$emit('emit-remove-pl-item', this.plitem.id);
    },
  },
}
</script>

<style>
</style>
